import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute, FirstLoginRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChangeInitialPassword from "@/pages/ChangeInitialPassword";
import Dashboard from "@/pages/Dashboard";
import Prospek from "@/pages/Prospek";
import ProspectDetail from "@/pages/ProspectDetail";
import FollowUp from "@/pages/FollowUp";
import Pipeline from "@/pages/Pipeline";
import SiswaKlien from "@/pages/SiswaKlien";
import Pendaftaran from "@/pages/Pendaftaran";
import RegistrationDetail from "@/pages/RegistrationDetail";
import MasterProgram from "@/pages/MasterProgram";
import Invoices from "@/pages/Invoices";
import Payments from "@/pages/Payments";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import StudentDetail from "@/pages/StudentDetail";
import ClientDetail from "@/pages/ClientDetail";
import Chatbot from "@/pages/Chatbot";
import ChatbotSettings from "@/pages/ChatbotSettings";
import WidgetDemo from "@/pages/WidgetDemo";
import ChatbotInbox from "@/pages/ChatbotInbox";
import Branches from "@/pages/Branches";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/chatbot" element={<Chatbot />} />
            <Route path="/widget-demo" element={<WidgetDemo />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-initial-password" element={<FirstLoginRoute><ChangeInitialPassword /></FirstLoginRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/prospek" element={<ProtectedRoute><Prospek /></ProtectedRoute>} />
            <Route path="/prospek/:id" element={<ProtectedRoute><ProspectDetail /></ProtectedRoute>} />
            <Route path="/followup" element={<ProtectedRoute><FollowUp /></ProtectedRoute>} />
            <Route path="/pipeline" element={<ProtectedRoute><Pipeline /></ProtectedRoute>} />
            <Route path="/siswa-klien" element={<ProtectedRoute><SiswaKlien /></ProtectedRoute>} />
            <Route path="/pendaftaran" element={<ProtectedRoute><Pendaftaran /></ProtectedRoute>} />
            <Route path="/pendaftaran/:id" element={<ProtectedRoute><RegistrationDetail /></ProtectedRoute>} />
            <Route path="/master-program" element={<ProtectedRoute><MasterProgram /></ProtectedRoute>} />
            <Route path="/tagihan" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
            <Route path="/pembayaran" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/laporan" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/notifikasi" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/siswa/:id" element={<ProtectedRoute><StudentDetail /></ProtectedRoute>} />
            <Route path="/klien/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
            <Route path="/chatbot-settings" element={<ProtectedRoute><ChatbotSettings /></ProtectedRoute>} />
            <Route path="/inbox" element={<ProtectedRoute><ChatbotInbox /></ProtectedRoute>} />
            <Route path="/cabang" element={<ProtectedRoute><Branches /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
